class FacetDrawer extends MainDrawer {
  constructor() {
    super();

    this.trigger = this.querySelector('.drawer__trigger')    
    if(this.trigger){
      this.trigger.addEventListener('click', () => this.loadAssets())
    }
  }        

  loadAssets() {           
    this.openDrawer()
    if(!document.getElementById('FACETSCSS') && !document.getElementById('FACETSJS')){
      this.classList.add('loading')
    }                
    loadCss('facets')
      .then(() => {this.classList.remove('loading')})                                              
      .catch(error => {console.error(error)})      
    loadScript('facets')        
      .catch(error => {console.error(error)})
  }  
}
customElements.define('facet-drawer', FacetDrawer);